import React from 'react';
import { useRotationStore } from '../../context/RotationContext';
import { SelectedRotationsWrapper } from '../stowage/common/voyageSelectionPanel/VoyageSelectionPanel.styles';

const SelectedRotationInfo: React.FC = () => {
    const { selectedStowageVoyages: selectedRotations } = useRotationStore();

    const getSelVoyLabel = (): string => {
        if (selectedRotations.length > 1) {
            return 'Selected voyages';
        }
        return 'Selected voyage';
    };

    return (
        <SelectedRotationsWrapper>
            {selectedRotations && selectedRotations.length > 0 && (
                <span className="info-text text-overflow">
                    {getSelVoyLabel()}{' '}
                    {selectedRotations.map((selectedRotation, index) => {
                        return (
                            <span className="selected-rotation-label" key={`rot-` + selectedRotation}>
                                {selectedRotation}
                                {selectedRotations.length > 1 && index !== selectedRotations.length - 1 && <span className="sep">,</span>}
                            </span>
                        );
                    })}
                </span>
            )}
        </SelectedRotationsWrapper>
    );
};

export default SelectedRotationInfo;
